import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './progression.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function ProgressionIcon(props: IconProps) {
  return <Icon className={props.className} />;
}
